<div id="list-example" class="list-group">
    <div class="grid-container1">
        <div class="item-left"><a href="#list-item-3" class="link-dark">روايات عن المعاناة</a></div>
        <div class="item-center"><a href="#list-item-2" class="link-dark">الأطفال الأبطال</a></div>
        <div class="item-right"><a href="#list-item-1" class="link-dark">الأطفال ذوو الاحتياجات الخاصة في لبنان
                والأزمات</a></div>
    </div>
    <div class="grid-container2">
        <div class="grid-item"><a href="#list-item-8" class="link-dark">الحلول المتوفرة</a></div>
        <div class="grid-item"><a href="#list-item-7" class="link-dark">معاناة الأهل</a></div>
        <div class="grid-item"><a href="#list-item-6" class="link-dark">آثار الأزمة الاقتصادية</a></div>
        <div class="grid-item"><a href="#list-item-5" class="link-dark">نتائج الجائحة</a></div>
        <div class="grid-item"><a href="#list-item-4" class="link-dark">رحلة أمل وألم</a></div>
        <div class="item1"><a href="#list-item-9" class="link-dark">الرجاء المفقود في ظل تقاعس الدولة</a></div>
    </div>
</div>


<div class="optionsClosed" id="options" (click)="close()">
    <div class="Menu">
        القائمة
    </div>

    <div class="timeline">

        <a href="#list-item-1" class="navbarItem">
            <div>
                <span class="Tooltiptext">الأطفال ذوو الاحتياجات الخاصة في لبنان والأزمات</span>
            </div>
            <div class="AnimatedBullet" data-aos="zoom-in" data-aos-anchor="#list-item-1"></div>
        </a>

        <a href="#list-item-2" class="navbarItem">
            <div>
                <span class="Tooltiptext">الأطفال الأبطال</span>
            </div>
            <div class="AnimatedBullet" data-aos="zoom-in" data-aos-anchor="#list-item-2"></div>
        </a>

        <a href="#list-item-3" class="navbarItem">
            <div>
                <span class="Tooltiptext">روايات عن المعاناة</span>
            </div>
            <div class="AnimatedBullet" data-aos="zoom-in" data-aos-anchor="#list-item-3"></div>
        </a>

        <a href="#list-item-4" class="navbarItem">
            <div>
                <span class="Tooltiptext">رحلة أمل وألم</span>
            </div>
            <div class="AnimatedBullet" data-aos="zoom-in" data-aos-anchor="#list-item-4"></div>
        </a>

        <a href="#list-item-5" class="navbarItem">
            <div>
                <span class="Tooltiptext">نتائج الجائحة</span>
            </div>
            <div class="AnimatedBullet" data-aos="zoom-in" data-aos-anchor="#list-item-5"></div>
        </a>

        <a href="#list-item-6" class="navbarItem">
            <div>
                <span class="Tooltiptext">آثار الأزمة الاقتصادية</span>
            </div>
            <div class="AnimatedBullet" data-aos="zoom-in" data-aos-anchor="#list-item-6"></div>
        </a>

        <a href="#list-item-7" class="navbarItem">
            <div>
                <span class="Tooltiptext">معاناة الأهل</span>
            </div>
            <div class="AnimatedBullet" data-aos="zoom-in" data-aos-anchor="#list-item-7"></div>
        </a>

        <a href="#list-item-8" class="navbarItem">
            <div>
                <span class="Tooltiptext">الحلول المتوفرة</span>
            </div>
            <div class="AnimatedBullet" data-aos="zoom-in" data-aos-anchor="#list-item-8"></div>
        </a>

        <a href="#list-item-9" class="navbarItem">
            <div>
                <span class="Tooltiptext">الرجاء المفقود وتقاعس الدولة</span>
            </div>
            <div class="AnimatedBullet" data-aos="zoom-in" data-aos-anchor="#list-item-9"></div>
        </a>

    </div>
</div>